import ResidentFeatures from "./ResidentFeatures";

export default ResidentFeatures;